import { useTranslation } from "react-i18next";

const FilterHeader = () => {
    const { t } = useTranslation("profanityPage");
    return (
        <>
            <h3 className="centerText">{t("blockedTerms")}</h3>
            <p className="filterInfoText">{t("filterInfoText")}</p>
        </>
    );
};

export default FilterHeader;
